import { render, staticRenderFns } from "./Avertissement.vue?vue&type=template&id=1a5e47e2&scoped=true&"
import script from "./Avertissement.vue?vue&type=script&lang=js&"
export * from "./Avertissement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e47e2",
  null
  
)

export default component.exports